import React from "react";
import { View } from "react-native";

type BeforeAfterProps = {
  color?: string;
};

const BeforeAfter: React.FC<BeforeAfterProps> = ({ color = "#000000" }) => {
  return (
    <View>
      <svg
        width="24"
        height="16"
        viewBox="0 0 24 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.1934 10.5558C14.8316 9.7015 15.8508 9.14844 16.9992 9.14844C17.8167 9.14844 18.5687 9.42872 19.1644 9.89843"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 15H21V1H13.5L11 15Z"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.998 7.64842C17.8265 7.64842 18.498 6.97685 18.498 6.14843C18.498 5.32 17.8265 4.64844 16.998 4.64844C16.1696 4.64844 15.498 5.32 15.498 6.14843C15.498 6.97685 16.1696 7.64842 16.998 7.64842Z"
          stroke={color}
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.01758 10.5558C3.65577 9.7015 4.67498 9.14844 5.82337 9.14844C6.64087 9.14844 7.39292 9.42872 7.98866 9.89843"
          stroke="black"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 15H1V1H12"
          stroke="black"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.82226 7.64842C6.65069 7.64842 7.32225 6.97685 7.32225 6.14843C7.32225 5.32 6.65069 4.64844 5.82226 4.64844C4.99384 4.64844 4.32227 5.32 4.32227 6.14843C4.32227 6.97685 4.99384 7.64842 5.82226 7.64842Z"
          stroke="black"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </View>
  );
};

export default BeforeAfter;
